import { render } from "./SuggestedSystemTable.vue?vue&type=template&id=bb742ed0&scoped=true&ts=true"
import script from "./SuggestedSystemTable.vue?vue&type=script&lang=ts"
export * from "./SuggestedSystemTable.vue?vue&type=script&lang=ts"

import "./SuggestedSystemTable.vue?vue&type=style&index=0&id=bb742ed0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb742ed0"]])

export default __exports__